import { Component, Input } from '@angular/core';
import { DATE_FORMAT } from '@app/app.constant';
import { DetailInfoTypeComponent } from '../detail-info-type.component';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'detail-info-datetime',
  templateUrl: './detail-info-datetime.component.html',
  standalone: false
})
export class DetailInfoDatetimeComponent extends DetailInfoTypeComponent {
  @Input() bsConfig: Partial<BsDatepickerConfig>;
  public datePlaceholder = DATE_FORMAT;

  ngOnInit() {
    super.ngOnInit();
    this.bsConfig.adaptivePosition = true
  }

  onDateChange(value: Date) {
    if (value === this.formControlObj.value) {
      return;
    }
    this.formControlObj.setValue(value);
  }

}